<template>
  <router-view/>
</template>

<style>
/* App.vue */
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
  min-height: 0;
  display: flex;
}

/* no scrolling */
/*html, body {
  overflow: hidden;
  height: 100%;
  margin: 0;
  padding: 0;
}*/
</style>
